import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=60e887d0&scoped=true&"
import script from "./Levels.vue?vue&type=script&lang=js&"
export * from "./Levels.vue?vue&type=script&lang=js&"
import style0 from "./Levels.vue?vue&type=style&index=0&id=60e887d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e887d0",
  null
  
)

component.options.__file = "Levels.vue"
export default component.exports